import React from 'react';
import Layout from '../../components/layout/Layout';
import { Card, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Users } from 'lucide-react';
import UserManagement from '../../components/admin/UserManagement';

const UserManagementPage = () => {
  return (
    <Layout>
      <div className="page-transition">
        {/* Header */}
        <Card className="mb-8 border-l-4 border-l-[#0A7EA4] shadow-lg">
          <CardHeader className="bg-gradient-to-r from-[#0A7EA4]/5 to-[#8B5CF6]/5">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-[#0A7EA4] rounded-lg">
                <Users className="w-8 h-8 text-white" />
              </div>
              <div>
                <CardTitle className="text-3xl text-[#0A7EA4]">User Management</CardTitle>
                <CardDescription className="text-base mt-1">
                  Manage users, subscriptions, and access control
                </CardDescription>
              </div>
            </div>
          </CardHeader>
        </Card>

        {/* User Management Component */}
        <UserManagement />
      </div>
    </Layout>
  );
};

export default UserManagementPage;
